<template>
  <d-modal
    v-if="showModal"
    @close="closeModal"
    class="crm-new-popup institution-prices"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h4 class="mt-3">
          <span style="font-weight: 100">Lista klientów z zadłużeniem</span>
        </h4>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">Osoba kontaktowa</th>
            <th
              scope="col"
              class="border-0">Dane firmy</th>
            <th
              scope="col"
              class="border-0">Adres</th>
            <th
              scope="col"
              class="border-0">Zadłużenie</th>
            <th
              scope="col"
              class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="customers">
          <tr
            v-for="(customer, index) of customers"
            v-if="loaded && customers.length > 0"
            :key="'user-' + index">
            <td class="align-middle">
              {{ customer.name }}
              <span class="bottom-text">
                Telefon: <span class="bottom-text-value-green">{{ customer.phone }}</span>
              </span>
              <span class="bottom-text">
                E-mail: <span class="bottom-text-value">{{ customer.email }}</span>
              </span>
            </td>
            <td class="align-middle">
              {{ customer.invoice_name }}
              <span class="bottom-text">NIP: <span class="bottom-text-value-green">{{ customer.invoice_nip }}</span></span>
            </td>
            <td class="align-middle">
              <span class="bottom-text">
                Miasto: <span class="bottom-text-value">{{ customer.invoice_city }}</span>
              </span>
              <span class="bottom-text">
                Kod pocztowy: <span class="bottom-text-value">{{ customer.invoice_post_code }}</span>
              </span>
              <span class="bottom-text">
                Ulica: <span class="bottom-text-value">{{ customer.invoice_address }}</span>
              </span>
            </td>
            <td
              class="align-middle text-danger"
              v-if="customer.dept !== 0">
              {{customer.dept.toFixed(2)}} zł
            </td>
            <td
              class="align-middle text-success"
              v-if="customer.dept === 0">
              {{customer.dept.toFixed(2)}} zł
            </td>
            <td
              class="align-middle"
              style="width: 70px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/klienci/edycja/' + customer.id)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="!loaded">
            <td
              colspan="5"
              class="text-center text-primary"
              style="height: 300px;vertical-align: middle;">
              Trwa ładowanie danych...
            </td>
          </tr>
          <tr v-if="loaded && customers.length < 1">
            <td
              colspan="5"
              class="text-center">
              Brak klientów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
      <pagination
        :meta-data="paginationMetaData"
        :initial-page="currentPage"/>
    </d-modal-body>
  </d-modal>
</template>

<script>
import debounce from 'lodash.debounce';
import ListUtils from '../../utils/ListUtils';
import HasPagination from '../../mixins/HasPagination.vue';
import Pagination from '../../components/common/Pagination.vue';

export default {
  name: 'dashboard-customers',
  mixins: [
    HasPagination
  ],
  data () {
    return {
      customers: [],
      loaded: false
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function,
      required: true
    },
  },
  components: {
    'pagination': Pagination
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeCustomers (userID) {
      ListUtils.removeItem(this, {
        endpointBase: '/customers/shops/delete/',
        id: userID,
        successTitle: 'Usunięto placówkę',
        successText: 'Wybrana placówka została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą placówkę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie placówki nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.loadCustomersShops();
        },
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      this.loaded = false;
      let where = {
        orders_in_dept: 1
      };
      this.loaded = false;
      ListUtils.loadItemsData(this, {
        endpoint: '/customers/items?page=' + this.currentPage,
        listField: 'customers',
        pagination: true,
        params: {
          where,
          per_page: 5
        }
      });
    },
  },
  watch: {
    showModal (to) {
      this.currentPage = 1;

      if (to) {
        this.customers = [];
        this.loadFilteredData();
      }
    }
  }
};
</script>

<style lang="scss">
  .institution-prices {
    margin-left: 0rem;
    .modal-dialog {
      .modal-content {
        width: 130%;
        .modal-body {
          overflow: auto;
          max-height: 760px;
        }
      }
    }
  }
</style>
